import useCommonModal from '@/compositions/useCommonModal';
import downloadBlob from '@/utils/downloadBlob';
import { ref } from '@vue/composition-api';
import {
  getControlsHistory,
  getHistoryProperties,
  getNotificationsHistory,
  getObjectPropertiesHistory
} from '@/api/media-server';

const useDownloadHistory = () => {
  const modalComposition = useCommonModal();

  /**
   * Download the properties history of a set of objects
   */

  const downloadHistory = (arr, modeSelection = 'day') => {
    let state = ref({
      loading: false,
      error: false
    });
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'HistoryDate'
      },
      slots: {
        default: {
          component: () => import('@/components/history-card/HistoryDate'),
          bind: {
            state,
            modeSelection,
            withShape: true
          },
          on: {
            close() {
              modalComposition.modal.hide('HistoryDate');
            },
            input(range, shape) {
              const data = {
                ids: arr.value.map(item => item.id),
                from: `${range[0]} 00:00`,
                to: `${range[1]} 23:59`,
                shape
              };

              state.value.loading = true;
              state.value.error = false;

              getObjectPropertiesHistory(data)
                .then(res => {
                  downloadBlob(
                    res.data,
                    `PixelAdmin_PropertiesHistory_${range[0]}-${range[1]}-${shape}.csv`,
                    res.data.type
                  );
                  modalComposition.modal.hide('HistoryDate');
                })
                .catch(() => {
                  state.value.error = true;
                })
                .finally(() => {
                  state.value.loading = false;
                });
            }
          }
        }
      }
    });
  };

  /**
   * Download the history of a set of properties
   */
  const downloadHistorySetOfProperties = (arr, modeSelection = 'day') => {
    let state = ref({
      loading: false,
      error: false
    });
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'HistoryDate'
      },
      slots: {
        default: {
          component: () => import('@/components/history-card/HistoryDate'),
          bind: {
            state,
            modeSelection,
            withShape: false
          },
          on: {
            close() {
              modalComposition.modal.hide('HistoryDate');
            },
            input(range) {
              const data = {
                ids: arr.value.map(item => item.id),
                from: `${range[0]} 00:00`,
                to: `${range[1]} 23:59`
              };

              state.value.loading = true;
              state.value.error = false;

              getHistoryProperties(data)
                .then(res => {
                  downloadBlob(
                    res.data,
                    `PixelAdmin_PropertyHistory_${range[0]}-${range[1]}.csv`,
                    res.data.type
                  );
                  modalComposition.modal.hide('HistoryDate');
                })
                .catch(() => {
                  state.value.error = true;
                })
                .finally(() => {
                  state.value.loading = false;
                });
            }
          }
        }
      }
    });
  };

  /**
   * Download the controls history of a set of objects
   */
  const downloadControlsHistoryOfObjects = (arr, modeSelection = 'day') => {
    let state = ref({
      loading: false,
      error: false
    });
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'HistoryDate'
      },
      slots: {
        default: {
          component: () => import('@/components/history-card/HistoryDate'),
          bind: {
            state,
            modeSelection,
            withShape: false
          },
          on: {
            close() {
              modalComposition.modal.hide('HistoryDate');
            },
            input(range) {
              const data = {
                objects: arr.value.map(item => item.id),
                from: `${range[0]} 00:00`,
                to: `${range[1]} 23:59`
              };

              state.value.loading = true;
              state.value.error = false;

              getControlsHistory(data)
                .then(res => {
                  downloadBlob(
                    res.data,
                    `PixelAdmin_ControlsHistory_${range[0]}-${range[1]}.csv`,
                    res.data.type
                  );
                  modalComposition.modal.hide('HistoryDate');
                })
                .catch(() => {
                  state.value.error = true;
                })
                .finally(() => {
                  state.value.loading = false;
                });
            }
          }
        }
      }
    });
  };

  /**
   * Download the controls history of a set of objects
   */
  const downloadNotificationsHistoryOfObjects = (
    arr,
    modeSelection = 'day'
  ) => {
    let state = ref({
      loading: false,
      error: false
    });
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'HistoryDate'
      },
      slots: {
        default: {
          component: () => import('@/components/history-card/HistoryDate'),
          bind: {
            state,
            modeSelection,
            withShape: false
          },
          on: {
            close() {
              modalComposition.modal.hide('HistoryDate');
            },
            input(range) {
              const data = {
                ids: arr.value.map(item => item.id),
                from: `${range[0]} 00:00`,
                to: `${range[1]} 23:59`
              };

              state.value.loading = true;
              state.value.error = false;

              getNotificationsHistory(data)
                .then(res => {
                  downloadBlob(
                    res.data,
                    `PixelAdmin_NotificationsHistory_${range[0]}-${range[1]}.csv`,
                    res.data.type
                  );
                  modalComposition.modal.hide('HistoryDate');
                })
                .catch(() => {
                  state.value.error = true;
                })
                .finally(() => {
                  state.value.loading = false;
                });
            }
          }
        }
      }
    });
  };

  return {
    downloadHistory,
    downloadHistorySetOfProperties,
    downloadControlsHistoryOfObjects,
    downloadNotificationsHistoryOfObjects
  };
};
export default useDownloadHistory;
